// extracted by mini-css-extract-plugin
module.exports = {"input":"PriceFilter_input__gBvF_"};